import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "@/components/ui/table";

const formatCurrency = (value: number) =>
	new Intl.NumberFormat("pt-PT", {
		style: "currency",
		currency: "EUR",
		maximumFractionDigits: 2,
	}).format(value);

const normalizeNumber = (value: number | null | undefined) => {
	const parsed = Number(value ?? 0);
	return Number.isNaN(parsed) ? 0 : parsed;
};

type ClientSummary = {
	name?: string | null;
};

type ClosedRepairEntry = {
	id?: string | number | null;
	repairNumber?: string | number | null;
	client?: ClientSummary | null;
	storeBox?: string | number | null;
	problemDescription?: string | null;
	value?: number | null;
};

type ClosedTodayRepairsTableProps = {
	repairs?: ClosedRepairEntry[];
};

export function ClosedTodayRepairsTable({
	repairs = [],
}: ClosedTodayRepairsTableProps) {
	return (
		<div className="overflow-hidden rounded-lg border border-border/60 bg-card/70">
			<Table>
				<TableHeader>
					<TableRow className="bg-muted/50">
						<TableHead className="w-[80px]">#</TableHead>
						<TableHead className="w-[380px]">Cliente</TableHead>
						<TableHead className="w-[80px]">Caixa</TableHead>
						<TableHead className="w-[450px]">Problema</TableHead>
						<TableHead className="w-[200px]">Valor da reparação</TableHead>
					</TableRow>
				</TableHeader>
				<TableBody>
					{repairs.map((repair) => {
						const rowKey = repair.id ?? repair.repairNumber ?? "closed-row";
						return (
							<TableRow key={rowKey}>
								<TableCell>{repair.repairNumber ?? "-"}</TableCell>
								<TableCell>{repair.client?.name ?? "-"}</TableCell>
								<TableCell>{repair.storeBox ?? "-"}</TableCell>
								<TableCell>{repair.problemDescription ?? "-"}</TableCell>
								<TableCell>
									{formatCurrency(normalizeNumber(repair.value))}
								</TableCell>
							</TableRow>
						);
					})}
				</TableBody>
			</Table>
		</div>
	);
}
